import { runtimeEnv } from '../config/runtimeEnv';

export const GROWTHBOOK_API_HOST = runtimeEnv.growthbookApiHost;
export const GROWTHBOOK_CLIENT_KEY = runtimeEnv.growthbookClientKey;
